import React from 'react'

function Info() {
  return (
    <div className="about__info grid">
        <div className="about__box">
        <i className='bx bx-award about__icon'></i>
            <h3 className="about__title">Experience </h3>
              <span className="about__subtitle"> Novice Developer
              </span>
        </div>

        <div className="about__box">
        <i className='bx bx-briefcase about__icon'></i>
            <h3 className="about__title"> complited </h3>
              <span className="about__subtitle">1_project
              </span>
        </div>

        <div className="about__box">

        <i className='bx bx-support about__icon'></i>
            <h3 className="about__title"> Support </h3>
              <span className="about__subtitle"> online 24/7
              </span>
        </div>

    </div>
   
  )
}

export default Info